import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { reloadProfile } from '../../profile/actions';
import { CreateConnection } from '../NotificationHub';
import { updateNotifications } from '../actions';
import { NotificationData, NotificationsDispatch } from '../notifications-types';
import useNotificationData from './useNotificationData';
import { IntegrationEvent } from '../../types/integrationevent-types';

export default function useRealTimeNotifications() {
  const [loadingText, setLoadingText] = useState(null);
  const dispatch = useDispatch<NotificationsDispatch>();
  const { fetchNotifications, checkIfTemplateCopied, checkIfPdsCompleted } = useNotificationData();

  useEffect(() => {
    const connection = CreateConnection();

    const onReceiveNotification = (notification: NotificationData) => {
      dispatch(updateNotifications([notification]));
      checkIfTemplateCopied([notification]);
      checkIfPdsCompleted([notification]);
    };

    const onReceiveIntegrationEvent = (integrationEvent: IntegrationEvent) => {
      if (['AccountMaintenance', 'AccountFeatures', 'AccountSettings'].includes(integrationEvent.eventType)) {
        reloadProfile()(dispatch);
      }
    };

    const onReconnected = () => {
      fetchNotifications();
    };

    setLoadingText('Connecting...');
    connection.start().then(() => {
      setLoadingText(null);
    });

    connection.on('ReceiveNotification', onReceiveNotification);
    connection.on('ReceiveIntegrationEvent', onReceiveIntegrationEvent);
    connection.onreconnected(onReconnected);

    return () => {
      connection.stop();
      connection.off('ReceiveNotification', onReceiveNotification);
      connection.off('ReceiveIntegrationEvent', onReceiveIntegrationEvent);
    };
  }, []);

  return { loadingText };
}
